export default function saveRecordLeaveIframe(params){
  this.saveRecordIframe(params, true);
}